module.exports = __webpack_public_path__ + "img/2logo.350cbad3.svg";